import { render, staticRenderFns } from "./BookingStatus.vue?vue&type=template&id=5bc5f1d6&scoped=true"
import script from "./BookingStatus.vue?vue&type=script&lang=js"
export * from "./BookingStatus.vue?vue&type=script&lang=js"
import style0 from "./BookingStatus.vue?vue&type=style&index=0&id=5bc5f1d6&prod&lang=scss&scoped=true"
import style1 from "./BookingStatus.vue?vue&type=style&index=1&id=5bc5f1d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc5f1d6",
  null
  
)

export default component.exports